import Immutable from 'immutable';
import isEmpty from 'lodash/isEmpty';

export default list => {
  const deserializedList = Immutable.Map.isMap(list) ? list.toJS() : list;
  if (isEmpty(deserializedList)) {
    return null;
  }

  return {
    list_id: deserializedList.id,
    list_purpose: deserializedList.listType,
    list_title: deserializedList.name,
    list_visibility: `${deserializedList.agencyScope}_${deserializedList.intendedLocale}`
  };
};
